import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import LandingPage from './Pages/LandingPage/LandingPage';
import LoginPage from './Pages/LoginPage/LoginPage';
import SignupPage from './Pages/SignupPage/SignupPage';
import ResetPassPage from './Pages/ResetPassPage/ResetPassPage';
import ForgotPassPage from './Pages/ForgotPassPage/ForgotPassPage';
import DashboardPage from './Pages/DashboardPage/DashboardPage';


import ProtectedRoutes from './Utils/ProtectedRoutes';

function AppRouter() {
  return (
    <Router> 
        <Routes>
          {/* routes publicly visible.*/}
          <Route path="/" element={<LandingPage />} />
          <Route path="/api/login" element={ <LoginPage />} />
          <Route path="/api/signup" element={<SignupPage />} />

          <Route path="/api/signup" element={<SignupPage />} />
          <Route path="/api/password/forgot" element={<ForgotPassPage />} />
          <Route path="/api/password/reset" element={<ResetPassPage />} />
          {/* routes protected for various reasons.*/}
          <Route element={<ProtectedRoutes/>}>
            <Route path="/dashboard" element={<DashboardPage />} />
            {/* <Route path="/dashboard/postings" element={<BountyPostingsPage />} />
            <Route path="/dashboard/submissions" element={<BountySubmissionsPage />} />
            <Route path="/dashboard/account" element={<BountyAccountPage />} />
            <Route path="/dashboard/home" element={<BountyHomePage />} /> */}
          </Route>
        </Routes>
    </Router>
  );
};

export default AppRouter;